import React from 'react'
import common from '../../../assets/common.jpg'
import MegaNavbar from '../../../Components/MegaNavbar'
import Drnadiagul from '../../../assets/CVs/Mathematics/Drnadiagul.pdf' 
import DrHinaZahir from '../../../assets/CVs/Mathematics/Dr. Hina Zahir CV.pdf' 
// import MsSADIAHABIBRESUME from '../../../assets/CVs/Biochemistry/DrMAMOONAALAM_Cv.pdf'
import Footer from '../../../Components/Footer'

const Mathematics = () => {
  return (
    <>

    

   
    <MegaNavbar/>
     <section id="team" className="team section-bg">
        <div className="container">

      <div className="section-title">
        <h2>Mathematics</h2>
      
        <p> Faculty of Mathematics.</p>
      </div>

      <div className="row">

      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Nadia  Gul</h4>
              <span> Assistant Professor Department of Mathematics.</span>
              <p> Assistant Professor Department of Mathematics Shaheed Benazir Bhutto Women University Peshawar .</p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i>   nadia.gul@sbbwu.edu.pk    </p>
              <div className="social">
                <a href={Drnadiagul}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Hina Zahir</h4>
              <span> Assistant Professor Department of Mathematics.</span>
              <p> Assistant Professor Department of Mathematics Shaheed Benazir Bhutto Women University Peshawar.             </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i> hina.zahir@sbbwu.edu.pk    </p>
              <div className="social">
                <a href={DrHinaZahir}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>

        {/* Repeat the above structure for other team members */}

      </div>

    </div>
  </section>
      <Footer/>
     

    </>
  )
}

export default Mathematics

